
import { defineComponent } from 'vue';
import Icon from "./Icon.vue";

export default defineComponent({
    name: "v-rating",
    components: {
        Icon,
    },
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        }
    },
    data() {
        return {
            width: 48,
            star_1: false,
            star_2: false,
            star_3: false,
            star_4: false,
            star_5: false,
        }
    },
    methods: {
        toggle(n : any) {
            if(n == 1)
            {
                this.star_1 = true;
                this.star_2 = false;
                this.star_3 = false;
                this.star_4 = false;
                this.star_5 = false;
            }
            else if(n == 2)
            {
                this.star_1 = true;
                this.star_2 = true;
                this.star_3 = false;
                this.star_4 = false;
                this.star_5 = false;
            }
            else if(n == 3)
            {
                this.star_1 = true;
                this.star_2 = true;
                this.star_3 = true;
                this.star_4 = false;
                this.star_5 = false;
            }
            else if(n == 4)
            {
                this.star_1 = true;
                this.star_2 = true;
                this.star_3 = true;
                this.star_4 = true;
                this.star_5 = false;
            }
            else if(n == 5)
            {
                this.star_1 = true;
                this.star_2 = true;
                this.star_3 = true;
                this.star_4 = true;
                this.star_5 = true;
            }

            this.$emit('score', n);
        },
        getImage(n : boolean) {
            return n ? "images/papsi_star_on_icon.svg" : "images/papsi_star_off_icon.svg";
        },
    }
})
